import { render, staticRenderFns } from "./keterlibatan.vue?vue&type=template&id=6f53072a"
import script from "./keterlibatan.vue?vue&type=script&lang=js"
export * from "./keterlibatan.vue?vue&type=script&lang=js"
import style0 from "./keterlibatan.vue?vue&type=style&index=0&id=6f53072a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports